import { Box, Button, ButtonProps, CircularProgress } from '@mui/material';
import { observer } from "mobx-react-lite";

interface BaseLoadingButtonProps extends ButtonProps {
    isLoading: boolean,
    children: JSX.Element
}

const BaseLoadingButton = observer((props: BaseLoadingButtonProps) => {
    const { children, isLoading, ...other } = props;
    return (
        <Box sx={{ position: 'relative', width: other.fullWidth ? "100%" : "auto" }}>
            <Button
                {...other}
            >
                {children}
            </Button>
            {isLoading && (
                <CircularProgress
                    size={24}
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                        marginLeft: '-12px',
                    }}
                />
            )}
        </Box>
    );
});

export default BaseLoadingButton;
